import { render, staticRenderFns } from "./ContactForms.vue?vue&type=template&id=4ed3e457&"
import script from "./ContactForms.vue?vue&type=script&lang=js&"
export * from "./ContactForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports